function sendKarsaOrder($shopId, $documentNumber) {
    karsaMonitorCollector.sendOrder($shopId, $documentNumber);
}

function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm)
            .closest('form')
            .find('input[name="registered"]'),
        isRegInput = $(elm).attr('data-box') == 'registration_user_box';

    if (!$(elm).is(':checked')) {
        $('#' + $(elm).attr('data-box')).addClass('hide');
        $registeredInputs.val(0);

        if (isRegInput) {
            $('.js-reg-text').addClass('h-nodisplay');
        }
    } else {
        $('#' + $(elm).attr('data-box')).removeClass('hide');
        $registeredInputs.val(1);

        if (isRegInput) {
            $('.js-reg-text').removeClass('h-nodisplay');
        }
    }
}

$(function() {
    // old stuff from modules.ctp
    $('input[name="shipping_id"]').bind('change', function() {
        const $form = $('.js-form-cart-modules');

        $('input[name="shipping_method"]').val($(this).data('name'));

        $('input[name="shipping_id"]').each(function() {
            const isChecked = $(this).is(':checked');

            for (const inputName of [
                'branch_id',
                'shipping_module_id',
                'shipping_name',
                'shipping_address',
                'shipping_post_code',
                'shipping_city',
                'shipping_phone',
            ]) {
                $(this)
                    .closest('.shopping-modules__item')
                    .find('input[name="' + inputName + '"]')
                    .attr('disabled', !isChecked);
            }
        });

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').prop('disabled', false);
        $('input[name="payment_id"]')
            .filter(function(index) {
                return _.indexOf(payments, parseInt($(this).val())) == -1;
            })
            .prop('disabled', true)
            .prop('checked', false)
            .trigger('change');

        if (
            $(this).val() !=
            $('[name="branch_id"]')
                .parents('.shopping-modules__item')
                .find('[name="shipping_id"]')
                .val()
        ) {
            $('[name="branch_id"]:checked')
                .prop('checked', false)
                .trigger('change');
        }

        if ($(this).is(':checked')) {
            if ($('#error-shipping').is(':visible')) {
                $('#error-shipping').hide();
            }
            if ($('#error-branch').is(':visible')) {
                $('#error-branch').hide();
            }
        }
    });

    $('.shopping-form').on('click', '.js-tigger-login-modal', function(event) {
        event.preventDefault();

        $('#login-modal').modal('show');
    });

    $('input[name="payment_id"]').on('change', function() {
        $('input[name="payment_method"]').val($(this).data('name'));

        if ($('#error-payment').is(':visible')) {
            $('#error-payment').hide();
        }
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    $('input[name="branch_id"]').on('change', function() {
        if ($(this).val() && $('#error-branch').is(':visible')) {
            $('#error-branch').hide();
        }
    });

    function performFormSubmit(form) {
        let result = true;

        if (!$('[name="payment_id"]').is(':checked')) {
            $('#error-payment').fadeIn(500);
            result = false;
        } else {
            if ($('#error-payment').is(':visible')) {
                $('#error-payment').fadeOut(500);
            }
        }

        if (!$('[name="shipping_id"]').is(':checked')) {
            $('#error-shipping').fadeIn(500);
            result = false;
        } else {
            if ($('#error-shipping').is(':visible')) {
                $('#error-shipping').fadeOut(500);
            }

            // branch pickup || parcelshop || packeta
            if (
                (!$('[name="branch_id"]').is(':checked') &&
                    $('[name="branch_id"]')
                        .parents('.shopping-modules__item')
                        .find('[name="shipping_id"]')
                        .is(':checked')) ||
                (!$('[r-gls-parcelshop-input]').val() &&
                    $('[r-gls-parcelshop-input]')
                        .parents('.shopping-modules__item')
                        .find('[name="shipping_id"]')
                        .is(':checked')) ||
                (!$('[r-dpd-parcelshop-input]').val() &&
                    $('[r-dpd-parcelshop-input]')
                        .parents('.shopping-modules__item')
                        .find('[name="shipping_id"]')
                        .is(':checked')) ||
                (!$('[r-zasielkovna-input]').val() &&
                    $('[r-zasielkovna-input]')
                        .parents('.shopping-modules__item')
                        .find('[name="shipping_id"]')
                        .is(':checked'))
            ) {
                $('#error-branch').fadeIn(500);

                result = false;
            } else {
                if ($('#error-branch').is(':visible')) {
                    $('#error-branch').fadeOut(500);
                }
            }
        }

        if (!result) {
            $('.c-msg--error:visible').slideHere();
        } else {
            $('.js-order-submit')
                .prop('disabled', true)
                .addClass('is-loading');

            // unset branch_id if not branch is selected
            if (
                !$('[name="branch_id"]')
                    .parents('.shopping-modules__item')
                    .find('[name="shipping_id"]')
                    .is(':checked')
            ) {
                $('[name="branch_id"]').val('');
            }
            if (
                !$('[r-sps-parcelshop-input]')
                    .parents('.shopping-modules__item')
                    .find('[name="shipping_id"]')
                    .is(':checked')
            ) {
                $('[r-sps-parcelshop-input]').val('');
            }
            if (
                !$('[r-zasielkovna-input]')
                    .parents('.shopping-modules__item')
                    .find('[name="shipping_id"]')
                    .is(':checked')
            ) {
                $('[r-zasielkovna-input]').val('');
                $('[r-zasielkovna-additional-input]').val('');
            }
            if (
                !$('[r-dpd-parcelshop-input]')
                    .parents('.shopping-modules__item')
                    .find('[name="shipping_id"]')
                    .is(':checked')
            ) {
                $('[r-dpd-parcelshop-input]').val('');
                $('[r-dpd-parcelshop-additional-input]').val('');
            }

            form.submit();
        }

        return result;
    }

    // modules validate
    $('.js-form-cart-modules')
        .on('submit', function(event) {
            event.preventDefault();
        })
        .validate({
            errorPlacement: function(error, element) {
                if (element.attr('type').match('checkbox')) {
                    error.insertAfter(element.siblings('label'));
                } else {
                    error.insertAfter(element);
                }
            },
            submitHandler: function(form) {
                $.get(
                    '/check-order-products',
                    {},
                    function(response) {
                        if (response.status) {
                            return performFormSubmit(form);
                        } else {
                            var message = [];

                            if (response.message) {
                                message.push(response.message);
                            }
                            if (response.quantityMessage) {
                                message.push(response.quantityMessage);
                            }
                            swal(
                                {
                                    title: '',
                                    text: message.join('<br>'),
                                    html: true,
                                    customClass: 'is-unavailable',
                                    type: 'warning',
                                    showCancelButton: true,
                                    cancelButtonText: response.buttons.cancel,
                                    confirmButtonColor: '#6ABA3F',
                                    confirmButtonText: response.buttons.ok,
                                    closeOnConfirm: true,
                                },
                                function(isConfirm) {
                                    if (isConfirm) {
                                        return performFormSubmit(form);
                                    } else {
                                        window.location.replace('/');
                                    }
                                }
                            );
                        }
                    },
                    'json'
                );

                return false;
            },
        });

    $('.js-form-cart-modules')
        .find('input[type="radio"]')
        .on('change', function() {
            const $form = $('.js-form-cart-modules');

            $.post(
                $form.data('update-action'),
                $form.serialize(),
                function(data) {
                    let recapTotals = Eshop.options.pricesWithVat
                        ? data.totals.total
                        : data.totals.subtotal;

                    Cart.updates.totals(data.totals);

                    for (const type of ['payment', 'shipping']) {
                        const isSelected =
                            $(`input[name="${type}_id"]:checked`).length > 0;
                        const value = data.totals[type];
                        const $valueEl = $(`.js-cart-recap-${type}`);

                        if (!isSelected) {
                            $valueEl
                                .removeClass('is-green')
                                .html($valueEl.data('empty'));
                        } else if (value) {
                            $valueEl
                                .removeClass('is-green')
                                .html(Format.price(value));
                        } else {
                            $valueEl.html($valueEl.data('free'));
                            $valueEl.addClass('is-green');
                        }

                        recapTotals -= value;
                    }

                    recapTotals -= data.totals.discount;

                    $('.js-recap-totals').html(Format.price(recapTotals));
                },
                'json'
            );
        });

    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($('#order-registered, #customer-registered'));

        $('#order-registered, #customer-registered').change(function() {
            check_hidden_inputs($(this));
        });
    }

    $('.js-shopping-voucher-trigger').on('click', function() {
        $('.js-shopping-voucher').addClass('is-open');
    });

    $('.js-shopping-voucher-close').on('click', function() {
        $('.js-shopping-voucher').removeClass('is-open');
    });

    $('.js-shopping-points-trigger').on('click', function() {
        $('.js-shopping-points').addClass('is-open');
    });

    $('.js-shopping-points-close').on('click', function() {
        $('.js-shopping-points').removeClass('is-open');
    });

    $('.js-shopping-sphere-trigger').on('click', function() {
        $('.js-shopping-sphere').addClass('is-open');
    });

    $('.js-shopping-sphere-close').on('click', function() {
        $('.js-shopping-sphere').removeClass('is-open');
    });

    $('.js-form-voucher').validate();
    $('.js-form-points').validate();
    $('.js-form-sphere').validate();

    $('#shopping-points-amount')
        .bind('change keyup', function() {
            if (parseInt($(this).val()) > $(this).attr('max')) {
                $(this).val($(this).attr('max'));
            }
            var rate = parseFloat(
                $(this)
                    .attr('discount-for-points')
                    .replace(',', '.')
            );
            $('#pointsDiscount').html(
                Format.price(parseInt($(this).val()) * rate)
            );
        })
        .trigger('change');

    $('.js-shopping-discounted-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        appendArrows: '.js-shopping-discounted-arrows',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.js-shopping-discounted-slider').on('afterChange', function(
        event,
        slick,
        currentSlide
    ) {
        bLazy.revalidate();
    });

    $('.js-import-form-input').on('change', function() {
        $('.js-import-form').submit();

        $(this).prop('disabled', true);
        $(this)
            .siblings('.c-btn')
            .addClass('is-loading');
    });
});

$('.cart-buttons__item .c-btn.is-cart[type="submit"]')
    .addClass('is-loading')
    .prop('disabled', true);
rEvent.on('Tracking.fetchedCartProducts', function() {
    $('.cart-buttons__item .c-btn.is-cart.is-loading[type="submit"]')
        .removeClass('is-loading')
        .prop('disabled', false);
});
